/** Canonical industry codes stored on SaaS Company.business_type */
export const BUSINESS_TYPES = [
  { value: 'Groceries & Supermarket', labelKey: 'industry.groceriesSupermarket', label: 'Groceries & Supermarkets' },
  { value: 'Bakery & Sweets', labelKey: 'industry.bakerySweets', label: 'Bakeries & Sweets' },
  { value: 'Mobile Phone & Accessories', labelKey: 'industry.mobilePhoneAccessories', label: 'Mobile Phone & Accessories' },
  { value: 'Pharmacy', labelKey: 'industry.pharmacy', label: 'Pharmacy' },
  { value: 'Perfume & Gift Shop', labelKey: 'industry.perfumeGiftShop', label: 'Perfume & Gift Shop' },
  { value: 'Electronics', labelKey: 'industry.electronics', label: 'Electronics' },
] as const;

export type BusinessTypeValue = (typeof BUSINESS_TYPES)[number]['value'];

export const DEFAULT_BUSINESS_TYPE: BusinessTypeValue = 'Groceries & Supermarket';

/** Legacy stored values → canonical retail types (matches backend industry.py). */
const LEGACY_BUSINESS_TYPE_MAP: Record<string, BusinessTypeValue> = {
  'Hardware IT Network': 'Electronics',
  'Auto Parts': 'Electronics',
  'Stationery Office': 'Perfume & Gift Shop',
  'Groceries Mini Mart': 'Groceries & Supermarket',
  'Mobile Laptop Shop': 'Mobile Phone & Accessories',
  'Hardware / IT / Network Equipment': 'Electronics',
  CCTV: 'Electronics',
  Networking: 'Electronics',
  Computers: 'Electronics',
  Laptops: 'Electronics',
  'IT Accessories': 'Electronics',
  Mixed: 'Electronics',
};

export function normalizeBusinessType(value: string | undefined | null): BusinessTypeValue {
  const raw = (value || '').trim();
  if (BUSINESS_TYPES.some((bt) => bt.value === raw)) return raw as BusinessTypeValue;
  return LEGACY_BUSINESS_TYPE_MAP[raw] || DEFAULT_BUSINESS_TYPE;
}
